var _a;
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    fields_state_list: [],
    frozen_fields: [],
};
export var fieldSlice = createSlice({
    name: "field",
    initialState: initialState,
    reducers: {
        setFieldState: function (state, data) {
            state.fields_state_list = data.payload;
        },
        setFrozenFieldState: function (state, data) {
            state.frozen_fields = data.payload;
        },
        setTotalFreezeRows: function (state, data) {
            state.freeze_rows = data.payload;
        },
    },
});
export var setFieldState = (_a = fieldSlice.actions, _a.setFieldState), setFrozenFieldState = _a.setFrozenFieldState, setTotalFreezeRows = _a.setTotalFreezeRows;
export default fieldSlice.reducer;
